import { Route } from '@angular/router';
import { authGuard } from '../shared/guards/auth.guard';
import { adminGuard } from '../shared/guards/admin.guard';

export const adminRoutes: Route[] = [
    { path: 'users', loadComponent: () => import('./users/users.component').then(m => m.UsersComponent), canActivate: [authGuard, adminGuard] },
    { path: 'plans', loadComponent: () => import('./plans/plans.component').then(m => m.PlansComponent), canActivate: [authGuard, adminGuard] },
    { path: 'roles', loadComponent: () => import('./roles/roles.component').then(m => m.RolesComponent), canActivate: [authGuard, adminGuard] },
    { path: 'subscriptions', loadComponent: () => import('./subscriptions/subscriptions.component').then(m => m.SubscriptionsComponent), canActivate: [authGuard, adminGuard] },
];